import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { map } from 'rxjs/operators';
import { UiAuthService } from '@fullyops/legacy/ui';
import { ApiTenantConfigurationService } from '@fullyops/data/tenant-configuration/api-adapter';
import { UserResponse } from '@fullyops/legacy/data/api/types/User';
import { SupportTicketResponse } from '@fullyops/legacy/data/api/types/SupportTicket';
import { FormTemplateFields } from '@fullyops/legacy/ui/ui-shared/form-template/form-template.component';
import { TimeZoneDateFormatterService } from '@fullyops/shared/services/date-formatter.service';

@Component({
  selector: 'crm-working-hours-registry',
  templateUrl: './working-hours-registry.component.html',
  styleUrls: ['./working-hours-registry.component.scss'],
  standalone: false,
})
export class WorkingHoursRegistryComponent implements OnInit {
  constructor(
    protected authService: UiAuthService,
    public timezoneDate: TimeZoneDateFormatterService,
    private tenantConfigurationController: ApiTenantConfigurationService,
  ) {}

  @Input() isDetailPage: boolean;
  @Input() usersAssignees$: BehaviorSubject<UserResponse[]>;
  @Input() ticket$: BehaviorSubject<SupportTicketResponse>;

  assignees$ = new BehaviorSubject<[]>([]);
  selected = new UntypedFormControl(0);
  formFields: FormTemplateFields<any>[] | FormTemplateFields<any>[][];

  setDefaultWorkingPeriodAssignees$ = this.tenantConfigurationController
    .getConfigurationsByLabel({
      label: 'ASSIGN_WORK_ORDER_ASSIGNEES_TO_WORK_PERIODS_BY_DEFAULT',
    })
    .pipe(map((configuration) => configuration.value == 'true'));

  setDefaultTravelAssignees$ = this.tenantConfigurationController
    .getConfigurationsByLabel({
      label: 'ASSIGN_WORK_ORDER_ASSIGNEES_TO_TRAVELS_BY_DEFAULT',
    })
    .pipe(map((configuration) => configuration.value == 'true'));

  async ngOnInit() {
    this.initAssignees();
  }

  initAssignees() {
    this.usersAssignees$
      .pipe(
        map((users) =>
          users.map((user) => ({
            id: user.id,
            name: `${user.firstName} ${user.lastName}`,
          })),
        ),
      )
      .subscribe(this.assignees$);
  }
}
